import { useParams } from 'react-router';

import {
  useScenarioDetailsContext,
  useReviewContext,
} from '@app-velocity/modules/scenarios';

import { useCreateReviewHeatMap } from '../../../../../../hooks/useCreateReviewHeatMap/useCreateReviewHeatMap';
import { ClickMapActions } from '../ClickMapActions/ClickMapActions';

export const RenderReviewClickMapButton = () => {
  const { scenario } = useScenarioDetailsContext();
  const { review } = useReviewContext();
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const { generateHeatMap, clearHeatMap } = useCreateReviewHeatMap(
    review.id,
    scenario.id || '',
    workspaceId || '',
    scenario.prototypePages || [],
    scenario.prototypePartials || []
  );

  return <ClickMapActions generate={generateHeatMap} clear={clearHeatMap} />;
};
